import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatTableModule, MatTabsModule } from '@angular/material';


import { SearchService } from 'app/core/pages/search/search.service';
import { SearchComponent } from 'app/core/pages/search/search.component';
import { SearchClassicComponent } from 'app/core/pages/search/tabs/classic/classic.component';
import { SearchTableComponent } from 'app/core/pages/search/tabs/table/table.component';
import { CommonModule } from '@angular/common';


const routes = [
    {
        path     : 'search',
        component: SearchComponent,
        resolve  : {
            search: SearchService
        }
    }
];

@NgModule({
    declarations: [
        SearchComponent,
        SearchClassicComponent,
        SearchTableComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        CdkTableModule,

        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatTabsModule,

        CommonModule,
        
      
        MatFormFieldModule,
        MatInputModule
    ],
    providers   : [
        SearchService
    ]
})
export class SearchModule
{
}
